/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 홍보결과>관심표명자 상담일자 컴포넌트
 * 버전 : 1.0
 * 파일명 : DateRangePickerInterestDialogCouncel.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-07-17
 * ================================================================ 
 * 수정 : 2025-07-17, 강동형 : 저작권 추가, 구조 변경에 따른 트리거 추가
 *================================================================
 */

import { useState, useEffect } from 'react'
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { ko } from 'date-fns/locale/ko'
import { Box, Typography } from '@mui/material';
import Icon_Calender from '@mui/icons-material/CalendarTodayOutlined';
import { usePromoDialogInterest } from 'src/stores/PromoStore';


//DateRangePicker
//두개의 박스를 가진 DatePicker 컴포넌트
//둘 사이의 날짜를 전역저장소로 저장해 리렌더링 최소화
//같은 박스가 두 개이므로 하나의 스타일을 조정했을 시, 다른 것도 같이 조정할 것 권장

//작동에는 문제가 없으나 포커스 에러로그가 출력되는 현상이 있음 -> 수정필요함

// 
const safeToDate = (value: string | Date | null | undefined): Date | null => {
  if (!value) return null;
  return typeof value === 'string' ? new Date(value) : value;
};

interface Props{
  resetTrigger:number
}

const DateRangePickerInterestDialogCouncel = ({resetTrigger}:Props) => {
  const start_date = usePromoDialogInterest((state)=>state.startCouncel)
  const end_date = usePromoDialogInterest((state)=>state.endCouncel)
  const [startDate, setStartDate] = useState<Date | null>(safeToDate(start_date));
  const [endDate, setEndDate] = useState<Date | null>(safeToDate(end_date));
  const [open,setOpen] = useState(false)
  const setField = usePromoDialogInterest((state)=>state.setField)

  useEffect(() => {
    setStartDate(safeToDate(start_date));
    setEndDate(safeToDate(end_date));
  }, [start_date, end_date]);

  useEffect(()=>{
    if(resetTrigger !==0){
      setStartDate(null)
      setEndDate(null)
    }
  },[resetTrigger])

  const handleStart = (newValue: Date | null) => {
    setStartDate(newValue);
    if (newValue) {
      setField('temp_startCouncel',newValue.toString())
    }
    if (endDate && newValue && endDate < newValue) {
      setEndDate(newValue);
    }
  };

  const handleEnd = (newValue: Date | null) => {
    setEndDate(newValue)

    if (newValue) {
      setField('temp_endCouncel',newValue.toString())
    }

  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ko}>
      <Box display="flex" alignItems="center" gap="5px">
        <DatePicker
          open={open}
          onOpen={()=>setOpen(true)}
          onClose={()=>setOpen(false)}
          value={startDate}
          onChange={handleStart}
          maxDate={endDate ?? undefined}
          format="yyyy-MM-dd"
          slotProps={{
            textField: {
              //박스크기 스타일조정
              placeholder : '전체 기간',
              sx: {
                height:46,
                '& .MuiInputBase-root': {
                  height: 46,
                },
              },
              //내부 이미지 조정
              InputProps: {
                endAdornment: (
                  <Icon_Calender/>
                ),
                onClick:()=>setOpen(true)
              },
            },
          }}
          slots={{
            toolbar: undefined, // ✅ 상단 선택된 날짜 텍스트 제거
          }}
        />
        <Typography>~</Typography>
        <DatePicker
          value={endDate}
          onChange={handleEnd}
          minDate={startDate ?? undefined}
          format="yyyy-MM-dd"
          slotProps={{
            textField: {
              placeholder : '전체 기간',
              sx: {
                height:46,
                '& .MuiInputBase-root': {
                  height: 46,
                },
              },
              InputProps: {
                endAdornment: (
                  <Icon_Calender/>
                ),
              },
            },
          }}
          slots={{
            toolbar: undefined, // ✅ 상단 선택된 날짜 텍스트 제거
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}

export default DateRangePickerInterestDialogCouncel